import React from "react";
import { motion } from "framer-motion";
import "./AboutContent.css";
import IconRow from "../../assets/icons/AboutOurVision.png";
import LoveIcon from "../../assets/icons/LoveIcon.png";
import ReadyToStartBox from "../ReadyToStartBox/ReadyToStartBox";

const AboutContent = () => {


  return (
    <div className="about-content">
      {/* Section 1: Header */}
      <div className="about-header">
        <h1>Our <span className="highlight-blue">Vision</span></h1>
        <p>
          The brilliance is already within you. <br />
          We simply help shape it into content that resonates on LinkedIn — <br />
          building <b>trust</b>, sparking <b>connection</b>, and creating <b>opportunity</b>.
        </p>
      </div>

      {/* Section 2: Icon Row */}
      <motion.div
        className="about-icons"
        initial={{ scale: 0.3, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{
          duration: 0.3,
          ease: [0.22, 0.61, 0.36, 1],
        }}
      >
        <img src={IconRow} alt="Vision Icons" />
      </motion.div>

      {/* Section 3: Built With Love */}
      <motion.div
        className="about-love"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{
          duration: 0.8,
          ease: [0.22, 0.61, 0.36, 1],
        }}
      >
        <p>
          Built with{" "}
          <motion.span
            className="heart"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              delay: 1.2,
              duration: 0.4,
              ease: "easeOut",
            }}
          >
            <img src={LoveIcon} alt="Heart Icon" />
          </motion.span>{" "}
          for you, <br />
          by people who understand the real <br />
          power of <span className="highlight">LinkedIn</span>.
        </p>
      </motion.div>

      {/* Sections 4 and 5: Appearing Together */}
      <motion.div
        className="combined-sections"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{
          duration: 0.6,
          ease: [0.22, 0.61, 0.36, 1],
        }}
      >
        {/* Section 4: Why I Built Brandly */}
        <div className="about-brandly">
          <h1>Why I Built <span className="highlight-blue">Brandly?</span></h1>
          <p>
            My first startup <span className="highlight">Collegeshala</span>, raised <span className="highlight">$250K</span> from a <span className="highlight">Singaporean Investor</span> because I used to write about our startup on LinkedIn regularly. 
            It was time-consuming & consumed a lot of energy & creativity. But in the end, it was worth it.
          </p>
          <p>
            On one fine day, my co-founder got a DM from an Investor based in Singapore because he had been reading my content about our startup. That way our conversation started, which 2 months later resulted in a <span className="highlight">$250K</span> cheque. Since then, <span className="highlight">I have never stopped writing on LinkedIn.</span>
          </p>
          <p>
            I want all of you to have this opportunity now in the age of AI, so that you can tell your story, reach out to people, make an audience, and achieve whatever you have set out to do. Leave the complex AI stuff to us & you just focus on the idea & the story that you wish to share.
          </p>
          <p>
            Signing Off, <br />
            <span className="highlight-blue">Fazal</span>
          </p>
        </div>

        {/* Section 5: Call to Action */}
        <ReadyToStartBox/>
      </motion.div>
    </div>
  );
};

export default AboutContent;
